
export const hide = (hide: boolean): React.CSSProperties => ({
    display: hide ? 'none' : undefined,
    width: hide ? 0 : undefined,
})
